import { render, staticRenderFns } from "./LangSwitcherComponent.vue?vue&type=template&id=4daa32bf&scoped=true&"
import script from "./LangSwitcherComponent.vue?vue&type=script&lang=js&"
export * from "./LangSwitcherComponent.vue?vue&type=script&lang=js&"
import style0 from "./LangSwitcherComponent.vue?vue&type=style&index=0&id=4daa32bf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4daa32bf",
  null
  
)

export default component.exports